var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimeEffortIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.115 10.6022C9.29152 15.2461 5.21741 22.9527 5.21741 31.1865C5.21741 44.9188 16.3856 56.087 30.118 56.087C43.8503 56.087 55.0185 44.9188 55.0185 31.1865C55.0185 23.0382 51.0157 15.3885 44.3062 10.7161L40.1038 16.7561C44.8332 20.0467 47.6538 25.4314 47.6538 31.1865C47.6538 40.8589 39.7762 48.7365 30.1037 48.7365C20.4313 48.7365 12.5537 40.8589 12.5537 31.1865C12.5537 25.3744 15.4312 19.947 20.2318 16.6706L16.0864 10.6022H16.115Z",
    fill: "#0C233C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3286 5.21741H23.9353V22.9242H36.3286V5.21741Z",
    fill: "#0C233C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeEffortIcon);
export default __webpack_public_path__ + "static/media/TimeEffortIcon.8e48efb052bf80afd95d9b4642428deb.svg";
export { ForwardRef as ReactComponent };